// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"3a1fd948","82":"c33bb050","243":"53121f75","562":"82d58daf","598":"1e4d8194","671":"ce09c86c","890":"e4015f19","900":"9bce3469","905":"1e869e89"}[chunkId] + ".chunk.js";
};